<div class="preloader">
    <div class="preloader__inner">
        <div class="preloader__logo">
            <img src="assets/img/lemonmode_logo.png" alt="Lemonmode">
        </div>
        <div class="preloader__track">
            <div class="preloader__bar"></div>
        </div>
        <!-- <p class="preloader__text">Loading, please wait...</p>
     -->
    </div>
</div>